/**
 * Compiles the 52-field questionnaire data into a structured 
 * prompt for a Senior Growth Strategist AI.
 */
export const generateStrategyPrompt = (formData, sections) => {
  const businessName = formData.businessName || 'this business';
  
  let prompt = `Act as a Senior Growth Strategist and Business Consultant. 
I have completed a deep-dive discovery phase for "${businessName}". 

Your goal is to analyze the following data and produce a comprehensive 12-month Growth Roadmap. 
The roadmap should be practical, jargon-free (for a business owner), and prioritized based on their specific constraints (budget, team, capacity).

---
DISCOVERY DATA:
\n`;

  sections.forEach(section => {
    prompt += `[SECTION: ${section.title.toUpperCase()}]\n`;
    section.fields.forEach(field => {
      const answer = formData[field.name];
      if (answer) {
        prompt += `${field.label}: ${answer}\n`;
      }
    });
    prompt += `\n`;
  });

  prompt += `---
OUTPUT REQUIREMENTS:
1. Executive Summary: The "Big Picture" for the next 12 months.
2. The "Fix One Thing": Detailed plan to address their #1 priority mentioned in the final section.
3. Customer Psychology: Analysis of their ideal customer and how to handle their specific objections.
4. Channel Strategy: Recommendations on which of their current channels to scale or cut based on performance data.
5. 12-Month Roadmap: A month-by-month or quarter-by-quarter breakdown of actions.
6. Resource Check: Ensure the plan fits within their monthly budget of ${formData.monthlyBudget || 'the specified budget'} and their current team capacity.

Please write this in a professional, encouraging, and highly strategic tone.`;

  return prompt;
};